import React from 'react';
import RegisterPricing from '../../components/registerpricing';

const RegisterPricingContainer = () => <RegisterPricing />;

export default RegisterPricingContainer;
